export interface Doctype {
  category: string | null;
  categoryName: string | null;
  excludedTiers: string[];
  id: number;
  image: string;
  infoEn: string | null;
  infoMx: string | null;
  isAmortizationTable?: boolean;
  isB2bPartner: boolean;
  isCreditContract?: boolean;
  isCurp: boolean;
  isDefault: boolean;
  isEnabled: boolean;
  isForCompressedFile: boolean;
  isForDealer: boolean;
  isForLoanTape: boolean;
  isGuarantor: boolean;
  isOptional: boolean;
  isPrefilled: boolean;
  isRestricted: boolean;
  isRetentionLetter?: boolean;
  isRfc: boolean;
  isSendToCredit: boolean;
  isVisible: boolean;
  nameEn: string;
  nameMx: string;
  partnerTypes?: string[];
  position: number;
  requirements: string;
  teamCategory: string;
}

export enum DoctypeTeamCategory {
  SALES = 'Sales',
  RISK = 'Risk',
}

export enum DoctypeRequirementsType {
  ALL = 'all',
  INDIVIDUAL = 'individual',
  COMPANY = 'company',
  PARTNERS = 'partners',
}
